import { useContext } from 'react';
import { DashboardFilterContext } from './dashboardFilterContextDef';

export function useDashboardFilter() {
  return useContext(DashboardFilterContext);
}
